var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToolAdmin',{attrs:{"user":_vm.user,"tool-id":"CustomerServiceCallAnalysis","tool-name":"Call Analysis","tool-icon":"mdi-phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }